import axios from "axios";
import route from "ziggy-js";
import { computed, isRef } from "vue";
import {
    keepPreviousData,
    useInfiniteQuery,
    useQueryClient,
} from "@tanstack/vue-query";

async function fetchFiles(buildingId, query = "", page = 1) {
    const { data } = await axios.get(
        route("api.files.search", {
            page,
            building_id: buildingId,
            query,
        })
    );
    return data;
}

export function useFiles(buildingId, query = "") {
    const _query = computed(() => (isRef(query) ? query.value : query));
    const queryKey = computed(() => ["files", { buildingId, _query }]);
    const queryClient = useQueryClient();
    return {
        ...useInfiniteQuery({
            queryKey: queryKey.value,
            queryFn: ({ pageParam }) =>
                fetchFiles(buildingId, _query.value, pageParam),
            initialPageParam: 1,
            getNextPageParam: ({ meta }) => {
                if (meta.current_page >= meta.last_page) {
                    return undefined;
                }
                return meta.current_page + 1;
            },
            getPreviousPageParam: ({ meta }) => {
                if (meta.current_page <= 1) {
                    return undefined;
                }
                return meta.current_page - 1;
            },
            placeholderData: keepPreviousData,
            refetchOnMount: true,
        }),
        resetPageParams: () => {
            queryClient.setQueryData(queryKey.value, (data) => ({
                pages: data.pages.slice(0, 1),
                pageParams: data.pageParams.slice(0, 1),
            }));
        },
    };
}
